import React, { useState } from 'react'
import { ReactComponent as English } from '../../Assets/english.svg'
import { ReactComponent as Italy } from '../../Assets/italy.svg'
import { ReactComponent as Globe } from '../../Assets/globe.svg'
import { ReactComponent as ArrowDown } from '../../Assets/arrow-down.svg'
import { ReactComponent as ArrowUp } from '../../Assets/arrow-up.svg'
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next'

const Language = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const { i18n } = useTranslation();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLanguage = (language) => {
        i18n.changeLanguage(language);
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                variant="text"
                className='language'
                id="language-button"
                aria-controls={open ? 'language-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                aria-label="language"
            >
                {i18n.language === "it" ?
                    <Italy aria-label="Italian" />
                    :
                    i18n.language === "en" ?
                        <English aria-label="English" />
                        :
                        <Globe aria-label="Globe" />
                }
                {open ? <ArrowUp /> : <ArrowDown />}
            </Button>
            <Menu
                id="language-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'language-button',
                }}
                style={{ display: "flex", alignItems: "center" }}
            >
                <Button aria-label="Italiano" variant="text" style={{ color: 'black', borderBottom: "1px solid #EEEEEE", borderRadius: "0" }} className='language' onClick={() => handleLanguage('it')} ><Italy /> Italiano</Button>
                <Button aria-label="English" variant="text" style={{ color: 'black' }} className='language' onClick={() => handleLanguage('en')} ><English /> English</Button>
            </Menu>
        </>
    )
}

export default Language